var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg26LogoCtLight01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 145.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.04,9.74c-6.58-6.58-16.57-9.74-32.88-9.74h-29.72l-5.52,20.57c12.83-.21,26.03-.11,39.53.35,5.43.28,9.55,2.26,10.65,6.17,1.12,3.97-.87,8.4-4.95,11.29-2.72,1.93-5.85,3.04-11.24,3.04-2.8,0-32.03-.24-39.57-.07l-12.67,47.18h29.59l6.45-24.03h12.52c28.08,0,44.77-14.8,44.77-36.93,0-6.96-2.28-13.15-6.96-17.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.6,28.35c-19.59,2.6-40.22,5.95-60.61,10.22L90.47,0h29.87l4.26,28.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.65,88.53h-31.49l-1.92-15.5h-28.2l-10.09,15.5H29.69l10.58-15.5H0c39.25-11.78,86.12-19.83,127.58-24.87l6.07,40.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.26,45.05c10.88-1.04,21.06-1.84,30.25-2.44l-12.33,45.92h-29.6l11.68-43.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.75,0l-5.54,20.64c-18.93.41-49.05,2.24-83.18,6.38l7.26-27.03h81.46Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.55,138.95c15.75-9.98,25.64-19.37,26.24-26.22.34-3.92-1.93-6.33-5.71-6.33s-7.65,1.34-11.66,3.95l2.17-8.06c4.24-2.22,8.5-3.26,12.42-3.26,7.63,0,12.31,4.7,11.7,11.68-.71,8.15-8.81,17.22-22.63,26.81h16.11l-1.93,7.17h-28.24l1.54-5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.9,106.99h-16.24l-2.69,9.85c1.19-.13,2.24-.2,3.28-.2,7.63,0,12.59,5.15,11.96,12.39-.83,9.52-9.2,16.44-19.96,16.44-3.78,0-7.42-1.01-10.89-3.1l2.04-7.6c2.99,2.28,6.28,3.52,9.48,3.52,5.68,0,10.22-3.52,10.65-8.41.36-4.11-2.78-6.98-7.74-6.98-2.55,0-5.05.35-8.04,1l6.47-24.09h23.68l-2,7.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.88,99.03c8.55,0,13.1,6.13,12.2,16.37-1.5,17.09-11.57,30.07-23.44,30.07-8.55,0-13.1-6.13-12.2-16.44,1.49-17.02,11.56-30.01,23.43-30.01ZM255.05,138.3c6.39,0,12.54-9.91,13.61-22.11.54-6.2-1.54-9.98-5.19-9.98-6.39,0-12.48,9.91-13.55,22.11-.54,6.2,1.48,9.98,5.13,9.98Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg26LogoCtLight01);
export default __webpack_public_path__ + "static/media/26-logo-ct-light-01.36a9b72182ab769fd01294795dd29edd.svg";
export { ForwardRef as ReactComponent };